import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { FlexColumn } from 'ui-components/components/flex';
import { Gap } from 'ui-components/components/flex/gap';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './single-label-promotional-section.module.less';
import { US, AU, GB } from '../../../../../constants/country-codes';
import Global from '../../../../../store/global-selectors';
import AUCarrierLogos from '../../set-up-banner/svgs/AU_Logos.svg';
import GBCarrierLogos from '../../set-up-banner/svgs/GB_Logos.svg';
import USCarrierLogos from '../../set-up-banner/svgs/US_Logos.svg';

const defaultPromotionalConfig = {
  carrierLogos: USCarrierLogos,
  altText: messages.carrierLogosAlt,
};

const promotionalConfigByCountry = {
  [US]: defaultPromotionalConfig,
  [AU]: {
    carrierLogos: AUCarrierLogos,
    altText: messages.carrierLogosAlt,
  },
  [GB]: {
    carrierLogos: GBCarrierLogos,
    altText: messages.carrierLogosAlt,
  },
};

export const SingleLabelPromotionalSection = () => {
  const intl = useIntl();
  const homeCountry = useSelector(Global.selectSellerHomeCountry);

  const { carrierLogos, altText } = promotionalConfigByCountry[homeCountry] || defaultPromotionalConfig;

  return (
    <FlexColumn className={style['promotional-section']}>
      <FlexColumn className={style['promotional-content']} gap={Gap.Space16}>
        <Text className={style['promotional-header']} textType={TextType.H1} value={<FormattedMessage {...messages.promotionalHeader} />} />
        <Text
          className={style['promotional-subtext']}
          textType={TextType.Body}
          value={<FormattedMessage {...messages.promotionalSubtext} />}
        />
        <img alt={intl.formatMessage(altText)} className={style['carrier-logos']} src={carrierLogos} />
      </FlexColumn>
    </FlexColumn>
  );
};
